import {
  put, call, select, all,
} from 'lib/redux';
import * as types from 'constants/ActionTypes';
import {
  getInitParametersSaga, getCompanyInfoSaga, getAccountSummarySaga, getSubscriptionDashboardDataSaga,
} from 'features/userData/UserData.saga';
import {
  fetchOrderHistoryPageDataSaga,
} from 'features/orderHistory/OrderHistory.saga';
import { MAX_HISTORY_LENGTH } from 'constants/AppConstants';
import getOrderHistoryReportIDsService from 'services/getOrderHistoryReportIDs.service';
import { getLastYearRange } from 'features/orderHistory/components/filters/commonComponents/dateRangeFilter/DateFilter.utils';
import { logError } from 'utils/logger.utils';
import { isEntitledForSubscriptionDashboardSelector, isSubscriptionDashboardV2EnabledSelector } from 'utils/appSelectors.utils';

export function* fetchRecentReportIdsSaga() {
  try {
    const { customerId: userId, orgNodeId } = yield select(({ userData: { initParameters } }) => initParameters);

    const [defaultStartDate, defaultEndDate] = getLastYearRange();

    const endDate = new Date(defaultEndDate);

    endDate.setDate(endDate.getDate() + 1);

    const response = yield call(
      getOrderHistoryReportIDsService,
      {
        userIdList: [userId],
        orgNodeId,
        startDate: defaultStartDate,
        endDate: endDate.toLocaleDateString('en-US'),
        statusList: [],
        productIds: [],
        orgNodeList: [],
        top: MAX_HISTORY_LENGTH,
      },
    );

    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    const { reportIds } = response.json;

    yield put({ type: types.ORDER_HISTORY_REPORT_IDS_SUCCESS, reportIds });
  } catch (error) {
    logError('Error in fetchRecentReportIdsSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
    yield put({ type: types.LOAD_ORDER_HISTORY_ERROR, error: error.message });
  }
}

export function* loadRecentOrdersSaga() {
  try {
    yield put({ type: types.LOADING_ORDER_HISTORY_REPORTS });
    yield put({ type: types.CLEAR_REPORTS_DATA });

    yield call(getInitParametersSaga);

    yield call(fetchRecentReportIdsSaga);

    const reportIds = yield select(({ orderHistory }) => orderHistory.reportIds);

    yield call(fetchOrderHistoryPageDataSaga, reportIds);
  } catch (error) {
    logError('Error in loadRecentOrdersSaga', {
      error: error.message,
      errorCode: error.errorCode,
    });
    yield put({ type: types.LOAD_ORDER_HISTORY_ERROR, error: error.message });
  }
}

export function* loadDasboardPageSaga() {
  const isEntitledForSubscriptionDashboard = yield select(isEntitledForSubscriptionDashboardSelector);
  const isSubscriptionDashboardV2Enabled = yield select(isSubscriptionDashboardV2EnabledSelector);
  yield all([
    call(loadRecentOrdersSaga),
    (isEntitledForSubscriptionDashboard || isSubscriptionDashboardV2Enabled) ? call(getSubscriptionDashboardDataSaga) : call(getAccountSummarySaga),
    call(getCompanyInfoSaga),
  ]);
}
